import { columnNamesType, columnNamesTypeTableCollapse, OctTable } from "@oceantech/oceantech-ui";
import { useEffect, useState, useContext } from "react";
import CustomIconButton from "../../../../component/custom-icon-button/CustomIconButton";
import { formatDateToDDMMYYYY, formatMoney } from "../../../../utils/FormatUtils";
import { AppContext } from "../../../../appContext/AppContext";
import {
  CODE,
  DEFAULT_PAGE_INDEX,
  MAX_PAGE_SIZE,
  SELECTION_MODE,
  TYPE_WH,
  WAREHOUSE_ID,
  TYPE
} from "../../../../utils/Constant";
import { toast } from "react-toastify";
import { WMS_STATUS } from "../../../../phan-he-nhap-kho/constants/constansNhapKho";
import { getDsThuocXuatKho } from "../../../../phan-he-xuat-kho/services/servicesXuatKho";
import { Col, Row } from "react-bootstrap";
import { columnsBn, columnsDsThuoc } from "../../../constants/TongHopPhieuColumns";
import OctTableCollapse from "../../../../component/table/table-collapse-custom/OctTableCollapse";
import { useFormikContext } from "formik";
import { PhieuXuat } from "../../../../phan-he-xuat-kho/models/XuatKhoModel";
import { TableCustom } from "../../../../component/table/table-custom/TableCustom";
import {HOAN_TRA_DVKT} from "../../../Constant";

type Props = {
  id: string;
  isView?: any;
  statusPhieu?: any;
  warehouseExportType?: any,
  warehouseId?: any,
};

const ThongTinXuatThuoc = ({ id, statusPhieu, isView, warehouseExportType, warehouseId }: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const { values } = useFormikContext<PhieuXuat>();
  const [dsThuoc, setDsThuoc] = useState([])
  const [dsBn, setDsBn] = useState([])
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [showQuantity, setShowQuantity] = useState(false)
  const nameChild = "items"
  const getVatTuXuatKho = async () => {
    setIsLoading(true);
    try {
      const payload = {
        type: warehouseExportType?.code === HOAN_TRA_DVKT.DA_TONG_HOP.code ? TYPE_WH.IMPORT : TYPE_WH.EXPORT,
        slipId: id,
        pageSize: MAX_PAGE_SIZE,
        pageIndex: DEFAULT_PAGE_INDEX,
      }
      const { data } = await getDsThuocXuatKho(payload);
      if (CODE.SUCCESS === data.code) {
        setDsThuoc(data.data.content)
      }
    } catch (error) {
      toast.error('Lỗi tải danh sách vật tư, vui lòng thử lại')
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetSelectedList = (listPatient: any) => {
    let _dsBn = listPatient?.length ? listPatient : (values?.phieuXuatKhoAdd?.listPatient ?? [])
    setDsBn(_dsBn)
    const totalQuantityCount = _dsBn?.reduce((acc: number, cur: any) => {
      let item = (cur[nameChild] ?? [])?.reduce((acc2: number, cur2: any) => acc2 + cur2?.totalQuantity, 0)

      return acc + item
    }, 0);

    setTotalQuantity(totalQuantityCount)
  }

  useEffect(() => {
    id && getVatTuXuatKho();
  }, [id]);

  useEffect(() => {
    values?.phieuXuatKhoAdd?.listPatient?.length && handleSetSelectedList(values?.phieuXuatKhoAdd?.listPatient ?? [])
  }, [values?.phieuXuatKhoAdd?.listPatient]);

  return (
    <div className="bg-white spaces mb-5 pb-15 fl-1">
      <Row lg={2}>
        <Col>
          <TableCustom
            columns={columnsDsThuoc}
            data={dsThuoc ?? []}
            selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
            getSelectedRowsData={(row: any) => {
              handleSetSelectedList(row?.[0]?.listPatient ?? [])
              setShowQuantity(row?.[0]?.listPatient)
            }}
          />
        </Col>
        <Col className="table-xuat-thuoc-dialog">
          <OctTableCollapse
            customFieldParent={[{ field: "patientCode"}, { field: "patientName"}, { field: "patientGenderName"}, { field: "visitCode"}, { label: "Tuổi", field: "age" }, { field: "height"},{ field: "weight"}, { field: "doCreation", type: TYPE.DATE}, { label:"MÃ ICD", field: "diagnosisCode"},{ field: "comorbidity"}]}
            data={dsBn}
            columns={columnsBn}
            searchObject={{}}
            nameChildren={nameChild}
            noAction
            noToolbar
            isLevel
            setData={(value: any) => { }}
            selectData={(value: any) => { }}
          />
          {showQuantity && <b>Tổng số lượng: {totalQuantity}</b>}
        </Col>
      </Row>
    </div>
  );
};

export default ThongTinXuatThuoc;
